export default "__VITE_ASSET__026a8423__"